import { every, isArray, isEmpty, values } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { Helpers } from "../utils/helper";

export interface InputError {
  isValid?: boolean;
  message?: string;
}

export interface IErrors {
  [key: string]: InputError;
}

export const checkValidForm = (error: any) => {
  if (isEmpty(error)) {
    return false;
  }
  error = Helpers.flattenNestedObj(error); //TO FLATTEN OBJ TO 1 LEVEL
  if(isArray(error)){
    return every(values(error).map(e=>{
      return every(values(e), { isValid: true });
    }));
  }
  else{
    return every(values(error), { isValid: true });
  }
};

export const useForm = (initial: any, callback: Function, validate: any, additional_values?: any) => {
  const [values, setValues] = useState<any>(initial);
  const [errors, setErrors] = useState<IErrors>({});
  const [formValid, setFormValid] = useState<boolean>(false);
  const [additionalData, setAddData] = useState<boolean>(false);

  useEffect(()=>{
    setAddData(additional_values);
  },[additional_values])


  useEffect(() => {
    const results = validate(values,additionalData);
    setErrors(results);
    setFormValid(checkValidForm(results));
  }, [values, validate,  additionalData]);

  const handleChange = useCallback((event: any) => {
    if (event?.persist) {
      event.persist();
    }
    setValues((prev: any) => ({ ...prev, [event.target.name]: event.target.value }));
  }, []);

  const setFormValue = useCallback((update: any) => {
    setValues((prev: any) => ({ ...prev, ...update }));
  }, []);

  const setAdditionalData = useCallback((additional_data:any)=>{
    setAddData(additional_data);
  },[])

  return { handleChange, values, errors, formValid, setFormValue, setAdditionalData };

}
